// extracted by mini-css-extract-plugin
export default {"container":"Ll-z","bubbleNav":"Ml-z","graphic":"Nl-z","contact":"Ol-z"};